import Login from "../../../components/@access/Login";

import { routeTypes } from "../../../hooks/useSystemRoutes";

export default function LoginPage() {

    return (
        <Login 
            routeType={routeTypes.member}
        />
    )
}       